import { Fragment } from "react";
import Menu from "../../modules/public/menu/menu";
import Footer from "../../modules/public/footer/footer";
import usePage from "../../hooks/usePage";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import style from "./DevelopersPage.module.css";
import backendUrl from "../../utilities/backendUrl";

export const developersList = [
  {
    id: 32,
    title: "وب سرویس (API)",
    image: "/developers-image/api.png",
    url: "/developers/web-service",
    description:
      "در این وب سرویس شما با ارسال مشخصه های مرسوله خود اعم از وزن ،شهر مبدا ،مقصد و سایر موارد می‌توانید در لحظه قیمت و بارکد پستی دریافت کنید",
    downloadUrl: backendUrl + "/files/web-service/avaex-collection-v1.zip",
  },
  {
    id: 33,
    title: "پلاگین وردپرسی",
    image: "/developers-image/plugin.png",
    url: "/developers/plugin",
    downloadUrl: backendUrl + "/files/plugin/avaex-plugin-v1.1.0.zip",
    description:
      "این افزونه به شما این امکان را می‌دهد تا خدمات شرکت‌های پستی را به راحتی در بستر وردپرس و با استفاده از پلاگین WooCommerce پیاده‌سازی کنید.",
    videoUrl: backendUrl + "/videos/avaex-wp-plugin.mp4",
  },
  {
    id: 35,
    title: "پکیج PHP",
    image: "/developers-image/php-package.png",
    url: "/developers/php-package",
    description:
      "این پکیج با API سیستم حمل و نقل آواکس کار کنند. فرآیندهای مختلف مرتبط با حمل و نقل را آسان‌تر می‌کند و امکان مدیریت مرسولات را به صورت سریع و کارآمد از طریق Rest-API فراهم می‌آورد.",
    downloadUrl: backendUrl + "/files/package/php-package-v1.0.zip",
  },
  {
    id: 34,
    title: "اکستنشن دیجی‌کالا",
    image: "/developers-image/Ext.png",
    url: "/developers/digi-extension",
    description:
      "در این افزونه می‌توانید با یک کلیک سفارش‌های فروشگاه دیجی‌کالا خود را به آواکس و پست ارسال کرده و به صورت آنی بارکد معتبر پستی دریافت و به صورت خودکار در دیجی‌کالا ثبت کنید.",
    downloadUrl:
      "https://chromewebstore.google.com/detail/akpghcgnfclejkafbcgffkmjlajhcdic?utm_source=item-share-cb",
    videoUrl: backendUrl + "/videos/avaex-digikala-extension.mp4",
  },
];

const DevelopersPage = () => {
  const { pageSliders, pageImage, pageText } = usePage();

  return (
    <Fragment>
      <Menu />

      <main className="flex-grow-1">
        {pageSliders}

        <Container className="rtl-all mt-6">
          {pageText}

          <section className="d-flex justify-content-around my-5 row">
            {developersList.map(item => (
              <div key={item.id} className="col-12 col-sm-6 col-lg-3 d-flex">
                <Link to={item.url} className="card-top-img w-100">
                  <div className="light-shadow px-3 py-3 my-2 bg-body rounded card h-100 ">
                    <img
                      src={item.image}
                      className={`w-100 object-fit-cover rounded ${style.img}`}
                      alt={item.title}
                    />

                    <div className="d-flex flex-column flex-wrap mt-3 h-100">
                      <h5 className="w-100 mb-2">{item.title}</h5>
                      <p className="text-justify mb-2">{item.description}</p>
                      <button
                        className="btn-success-style text-center rounded mt-auto"
                        style={{ height: 44 }}
                      >
                        ادامه ی مطلب
                      </button>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </section>
        </Container>

        {pageImage}
      </main>

      <Footer />
    </Fragment>
  );
};

export default DevelopersPage;
